module.exports = __webpack_public_path__ + "img/MNX.08f37cab.svg";